<template>
  <div>
    <!-- begin: Child route (Preview) -->
    <router-view />
    <!-- end: Child route -->

    <div
      v-show="$route.path == '/PrintSummary/Barcodes/New'"
      class="kt-portlet kt-portlet--mobile"
    >
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="fas fa-file-alt"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            เพิ่มสรุปสินค้าคงค้าง
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <!-- begin: Stepper -->
        <div class="row">
          <div class="col-12">
            <div class="fss-stepper">
            <div class="fss-step fss-step--active">
              <div class="fss-step__badge">1</div>
              <div class="fss-step__title">เลือก Filter</div>
            </div>
            <div class="fss-connector"></div>
            <div class="fss-step">
              <div class="fss-step__badge">2</div>
              <div class="fss-step__title">ตรวจสอบข้อมูล</div>
            </div>
            <div class="fss-connector"></div>
            <div class="fss-step">
              <div class="fss-step__badge">3</div>
              <div class="fss-step__title">บันทึก + พิมพ์</div>
            </div>
          </div>
          </div>
        </div>
        <!-- end: Stepper -->

        <div class="kt-separator kt-separator--border-dashed kt-separator--space-sm"></div>

        <!-- begin: Filter Form -->
        <form class="kt-form" ref="filterForm" @submit.prevent="formSubmit">
          <!-- begin: Filter บังคับ -->
          <div class="row">
            <div class="col-12">
              <h5 class="kt-font-bold kt-margin-b-10">
                Filter บังคับ
                <small class="text-muted">
                  (เลือกอย่างใดอย่างหนึ่งเท่านั้น · เลือกได้หลายตัวแทนจำหน่าย —
                  เลือก 2 รายขึ้นไป = สร้างเอกสารรวม)
                </small>
              </h5>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
              <div class="form-group mb-3">
                <!-- FS-010: "ทั้งหมด" เป็น option แรกใน dropdown แทนปุ่มลอยนอกกล่องแบบเดิม
                     (แพตเทิร์นของระบบ — Barcodes.vue:1259) option ถูกใส่ที่ loader
                     ดู LoadreBHostAgentCodeOptions และ watcher reBHostAgentCode -->
                <!--
                  FS-058 — ติดเครื่องหมายช่องบังคับด้วยคลาสส่วนกลาง label-required
                    (App.vue:3965 — แถบแดงตั้งหน้า label · ใช้อยู่ ~98 component ทั้งระบบ)
                  ติดทั้ง 2 ช่องได้เพราะหัวข้อด้านบนกำกับไว้แล้วว่า "เลือกอย่างใดอย่างหนึ่งเท่านั้น"
                  จึงไม่ทำให้เข้าใจผิดว่าต้องกรอกทั้งคู่
                -->
                <label class="mb-1 label-required">
                  ชื่อตัวแทนจำหน่าย:
                  <small v-if="agentCodeCount > 0" class="text-muted">
                    (เลือกแล้ว {{ agentCodeCount }} ราย)
                  </small>
                </label>
                <treeselect
                  v-model="reBHostAgentCode"
                  :multiple="true"
                  :options="reBHostAgentCodeOptions"
                  :disabled="isGroupSelected"
                  :clear-on-select="true"
                  placeholder="กรุณาเลือกผู้ดูแลร้านค้า(ตัวแทน)"
                  ref="reBHostAgentCode"
                />
              </div>
            </div>

            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
              <div class="form-group mb-3">
                <!-- FS-010: "ทั้งหมด" เป็น option แรกใน dropdown แทนปุ่มลอยนอกกล่องแบบเดิม
                     (แพตเทิร์นของระบบ — Barcodes.vue:1259) option ถูกใส่ที่ loader
                     ดู LoadHeadAgentCodeOptions และ watcher HeadAgentCode -->
                <!-- FS-058 — ช่องบังคับคู่กับ "ชื่อตัวแทนจำหน่าย" (เลือกอย่างใดอย่างหนึ่ง) -->
                <label class="mb-1 label-required">
                  ตัวแทนจำหน่าย (Group):
                  <small v-if="groupCodeCount > 0" class="text-muted">
                    (เลือกแล้ว {{ groupCodeCount }} ราย)
                  </small>
                </label>
                <treeselect
                  v-model="HeadAgentCode"
                  :multiple="true"
                  :options="HeadAgentCodeOptions"
                  :disabled="isAgentSelected"
                  :clear-on-select="true"
                  placeholder="กรุณาเลือกสำนักงานใหญ่ (Group)"
                  ref="HeadAgentCode"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <!--
                jQuery-validate มองไม่เห็น <treeselect> (ไม่มี form control ที่มี name)
                จึงผูก rule ไว้กับ hidden input ตัวนี้แทน + ใช้ ignore: [] เพื่อไม่ให้ validator ข้าม hidden
                (pattern เดียวกับ AgentScoreList.vue:835 ที่ใช้ ignore: [])
                ข้อความ error จะถูกวางต่อท้าย input ตัวนี้ = ใต้ treeselect ทั้งสองช่องพอดี
              -->
              <input
                type="hidden"
                id="fssCreate_requiredFilter"
                name="fssCreate_requiredFilter"
                :value="requiredFilterValue"
              />
            </div>
          </div>
          <!-- end: Filter บังคับ -->

          <div class="kt-separator kt-separator--border-dashed kt-separator--space-sm"></div>

          <!-- begin: Filter ไม่บังคับ -->
          <!-- QA 08/10/2026 เรื่องที่ 5 — เดิม col-xl-3 ได้ 4 ช่องต่อแถว
               7 ช่องจึงเรียงเป็น 4+3 เหลือช่องว่างด้านขวาของแถวที่ 2 ดูไม่สมดุล
               เปลี่ยนเป็น col-xl-4 (3 ช่องต่อแถว) ได้ 3+3+1 ตามที่ลูกค้าขอ -->
          <div class="row">
            <div class="col-12">
              <h5 class="kt-font-bold kt-margin-b-10">
                Filter ไม่บังคับ
                <small class="text-muted">
                  (เลือกได้มากกว่า 1 ค่า · ไม่เลือก = ไม่กรอง)
                </small>
              </h5>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
              <div class="form-group mb-3">
                <label class="mb-1">เจ้าของทรัพย์สิน:</label>
                <treeselect
                  v-model="AssetOwnerId"
                  :multiple="true"
                  :options="AssetOwnerOptions"
                  :clear-on-select="true"
                  placeholder="กรุณาเลือก"
                />
              </div>
            </div>

            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
              <div class="form-group mb-3">
                <label class="mb-1">หมุนเวียน/ไม่หมุนเวียน:</label>
                <treeselect
                  id="Circulate"
                  v-model="Circulate"
                  :multiple="true"
                  :options="CirculateOptions"
                  placeholder="กรุณาเลือก"
                  ref="Circulate"
                />
              </div>
            </div>

            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
              <div class="form-group mb-3">
                <label class="mb-1">ช่วงคงค้าง:</label>
                <treeselect
                  id="PeriodRange"
                  v-model="PeriodRange"
                  :multiple="true"
                  :options="PeriodRangeOptions"
                  placeholder="กรุณาเลือก"
                  ref="PeriodRange"
                />
              </div>
            </div>

            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
              <div class="form-group mb-3">
                <label class="mb-1">ปี(สินค้า):</label>
                <treeselect
                  v-model="BarcodeYear"
                  :multiple="true"
                  :load-options="LoadBarcodeYearOptions"
                  v-on:open="reLoadBarcodeYearOptions"
                  :async="true"
                  v-on:select="ClearAfterselect"
                  searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                  placeholder="กรุณาเลือก"
                  :cacheOptions="true"
                  ref="BarcodeYear"
                />
              </div>
            </div>

            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
              <div class="form-group mb-3">
                <label class="mb-1">ปีคงค้าง:</label>
                <treeselect
                  id="PeriodYear"
                  v-model="PeriodYear"
                  :multiple="true"
                  :options="PeriodYearOptions"
                  placeholder="กรุณาเลือก"
                  ref="PeriodYear"
                />
              </div>
            </div>

            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
              <div class="form-group mb-3">
                <label class="mb-1">ประเภทสินค้า:</label>
                <treeselect
                  v-model="reBProductTypeId"
                  :multiple="true"
                  :options="reBProductTypeIdOptions"
                  :clear-on-select="true"
                  placeholder="กรุณาเลือก"
                />
              </div>
            </div>

            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
              <div class="form-group mb-3">
                <label class="mb-1">ชื่อสินค้า:</label>
                <treeselect
                  v-model="reBAssetCode"
                  :multiple="true"
                  :options="reBAssetCodeOptions"
                  :clear-on-select="true"
                  placeholder="กรุณาเลือก"
                />
              </div>
            </div>
          </div>
          <!-- end: Filter ไม่บังคับ -->

          <div class="kt-separator kt-separator--border-dashed kt-separator--space-sm"></div>

          <!-- begin: Actions -->
          <div class="row">
            <div class="col-xl-6">
              <button
                type="button"
                class="btn btn-sm btn-clean kt-margin-r-10"
                @click="goBack"
              >
                <i class="la la-arrow-left"></i>
                <span class="kt-hidden-mobile">กลับ</span>
              </button>
              <!--
                FS-011: "ล้างข้อมูล" ย้ายมาอยู่ฝั่งซ้ายคู่กับ "กลับ"
                เพราะเป็นปุ่มที่ "ไม่เดินหน้า" เหมือนกัน — วางไว้ข้าง "ประมวลผล" เสี่ยงกดพลาด
                ยังอยู่ใน <form> เดิม → type="reset" + @click="formReset" ทำงานเหมือนเดิมทุกประการ
                ใช้ btn-sm ให้สูงเท่าปุ่ม "กลับ" (บนจอเล็ก "กลับ" เหลือแต่ไอคอนเพราะ kt-hidden-mobile
                แต่ col-xl-6 จะกลายเป็นเต็มบรรทัด ปุ่มสองตัวจึงอยู่บรรทัดเดียวกันได้ไม่ตีกัน)
              -->
              <button
                type="reset"
                class="btn btn-sm btn-secondary"
                @click="formReset"
              >
                ล้างข้อมูล
              </button>
            </div>
            <div class="col-xl-6 text-right">
              <button type="submit" class="btn btn-primary">
                ประมวลผล →
              </button>
            </div>
          </div>
          <!-- end: Actions -->
        </form>
        <!-- end: Filter Form -->
      </div>
    </div>

    <!--
      FS-033 — popup ความคืบหน้าของขั้น "ประมวลผล" (spec §M กรณีที่ 1 ใน 5 กรณี)
      ของเดิมใช้ KTApp.blockPage ซึ่งไม่มี % ไม่มี log และกดยกเลิกไม่ได้

      ใช้ v-if ผูกกับ route โดยตั้งใจ (ไม่ใช่ v-show) — หน้า 3B ที่เป็น route ลูก
      ก็ mount popup ตัวเดียวกันไว้ ถ้าปล่อยให้อยู่ใน DOM พร้อมกัน จะมี id และ
      data-test ซ้ำกัน 2 ชุด ทั้ง jQuery และเทสจะจับผิดตัว
    -->
    <FormSummaryStockProgressModal
      v-if="isOnFilterStep"
      ref="progressModal"
      @finished="onProcessFinished"
    />
  </div>
</template>

<script>
import axios from "axios";
// Action Button Design System + Stepper ของโมดูลนี้ (QA เรื่องที่ 11 + 16)
import "./form-summary-stock-actions.css";
// FS-088 — tooltip ของปุ่มวงกลมเป็นแบบ Bootstrap (ผูกครั้งเดียวทั้งโมดูล เรียกซ้ำได้)
import { installFssTooltips } from "./form-summary-stock-tooltips";
installFssTooltips();
import router from "../../router";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
// FS-033 — popup ความคืบหน้าตัวเดียวกับที่ขั้น 3B / ขั้นที่ 6 ใช้
import FormSummaryStockProgressModal from "./FormSummaryStockProgressModal";

require("sweetalert2");

// ─────────────────────────────────────────────────────────────────────────────
// CR-FormSummaryStock F03 — ขั้นที่ 1 "เลือก Filter" (/PrintSummary/Barcodes/New)
//
// Dropdown ทั้ง 9 ตัว copy loader + markup มาจากหน้ารายงาน "Stock รายบาร์โค้ด"
//   SBP.Web/App/Components/Report/Barcodes.vue  (ระบุบรรทัดต้นทางกำกับไว้ทุก method)
// เพื่อให้ตัวเลือกที่ผู้ใช้เห็นในสองหน้านี้เป็นชุดเดียวกันเป๊ะ
//
// การส่ง state ข้าม step: ใช้ pattern ของ repo คือ "route ลูกอ่านค่าจาก $parent"
//   ต้นแบบ: SBP.Web/App/Components/BeerClaim/AddBeerClaim.vue (พ่อถือ state)
//         + SBP.Web/App/Components/BeerClaim/AddBeerClaimItem.vue:1113-1115 (ลูกอ่าน $parent)
//   → หน้านี้เป็น "พ่อ" ของ /New/Preview และ /New/GroupPreview จึงถือ filter + ผลประมวลผลไว้เอง
//     · FormSummaryStockPreview.vue:214-226  อ่าน $parent.processResult / filterLabels / filter
//     · FormSummaryStockGroupPreview.vue:347-413 อ่าน $parent.groupProcessResult / groupAgentCodes
//       (+ ถอยไปอ่าน processResult.agents และ filter.agentCodes ถ้าไม่มี — หน้านี้เซ็ตให้ครบทั้งคู่)
//
// ── spec ฉบับเซ็น 16/09/2026 (F03) ──────────────────────────────────────────
// Filter บังคับทั้ง 2 ตัวเป็น multi-select (ยังคง "เลือกได้อย่างใดอย่างหนึ่ง")
//   • เลือก 1 ราย     → POST /Api/FormSummaryStock/Process      → /New/Preview       (ของเดิม)
//   • เลือก 2 รายขึ้นไป → POST /Api/FormSummaryStock/GroupProcess → /New/GroupPreview (ขั้นที่ 3B)
//   • ตัวเลือก "ทั้งหมด" เป็น option แรกของ dropdown และใส่ให้เมื่อ dropdown นั้นมีตัวเลือกมากกว่า 1 รายการ
//     (FS-010 — เดิมทำเป็นปุ่มลอยนอกกล่อง ย้ายมาเป็น option ตามแพตเทิร์นที่ระบบใช้อยู่ Barcodes.vue:1259)
//     เลือก "ทั้งหมด" แล้ว watcher จะขยายเป็นรหัสจริงทุกตัวทันที → payload ที่ส่งไป API
//     ไม่มี sentinel "0" ปนไป และเหมือนกับตอนที่ยังเป็นปุ่มทุกประการ
//   • dropdown "ตัวแทนจำหน่าย (Group)" เหลือเฉพาะสำนักงานใหญ่ + ตัวแทนที่ไม่มีสาขา
//     (ส่ง IsHead = true ให้ Select2SearchAgentCodeQuery — ดู LoadHeadAgentCodeOptions)
//
// SweetAlert2 = ^8.2.3 (SBP.Web/package.json) → ใช้ option ชื่อ `type` (ไม่ใช่ `icon` ของ v9+)
// vue-treeselect = ^0.4.0 → options เป็น { id, label } และต้อง import CSS เอง
// ─────────────────────────────────────────────────────────────────────────────

// ตรงกับ SBP.Application/FormSummaryStock/Models/FormSummaryStockFilter.cs (FormSummaryStockFilterType)
const FILTER_TYPE_AGENT = "AGENT";
const FILTER_TYPE_GROUP = "GROUP";

// id ของ option "ทั้งหมด" ใน dropdown — ใช้ "0" ตรงกับแพตเทิร์นของระบบ (Barcodes.vue:1259)
// เป็นแค่ sentinel บนหน้าจอเท่านั้น ไม่เคยถูกส่งออกไปกับ payload (watcher ขยายเป็นรหัสจริงก่อนเสมอ)
const SELECT_ALL_ID = "0";

// ข้อความที่แสดงแทนรายการจริงเมื่อผู้ใช้เลือก "ทั้งหมด" (QA เรื่องที่ 9)
const SELECT_ALL_LABEL = "ทั้งหมด";

// CR-01 (08/10/2026) — รหัสสินค้าที่ไม่ติดตามการคงค้าง (เป็นของร้านค้า ไม่ใช่ของบริษัท)
//   ต้องตรงกับ FormSummaryStockConstants.ProductCodeCoolRoom / ProductCodeFontShop ฝั่ง server
const EXCLUDED_PRODUCT_CODES = ["COOL-ROOM-01", "FONT-SHOP-01"];

// treeselect คืนค่า id ตามชนิดที่ option ใส่ไว้ (บาง loader ใส่เป็น string เช่น ปีคงค้าง)
// แต่ FormSummaryStockFilter.cs ประกาศเป็น List<int> → บังคับชนิดตอนประกอบ payload
function toIntList(values) {
  if (!values || values.length === 0) return null;
  return values
    .map(function(v) {
      return parseInt(v, 10);
    })
    .filter(function(v) {
      return !isNaN(v);
    });
}

// FormSummaryStockFilter.AssetCode = List<string>
function toStringList(values) {
  if (!values || values.length === 0) return null;
  return values.map(function(v) {
    return String(v);
  });
}

// FS-078 — เลิกหน่วงเปิด popup ของ "ประมวลผลตัวแทนรายเดียว" (เดิม SINGLE_PROCESS_DEFER_MS = 700 ของ FS-033)
//   popup เปิดทันทีทั้งสองโหมด จึงไม่ต้องมี overlay คั่นช่วงหน่วงอีก

export default {
  components: {
    Treeselect,
    FormSummaryStockProgressModal,
  },
  computed: {
    // treeselect แบบ multiple คืนค่าเป็น array เสมอ — แต่กัน null/undefined ไว้ให้ทุกที่ที่อ่านค่า
    // ใช้ .length ได้อย่างปลอดภัย (ตัว template ผูกกับ computed เหล่านี้ ไม่ผูกกับ v-model ตรง ๆ)
    // FS-016 — v-model เก็บ sentinel "0" ไว้ตามที่ผู้ใช้เลือก (กล่องจะได้โชว์ chip "ทั้งหมด"
    // ชิ้นเดียว ไม่ระเบิดเป็นรหัสทุกราย) การขยายเป็นรหัสจริงย้ายมาทำที่นี่แทน
    // ทุกอย่างที่อยู่ถัดจากนี้ (count / isGroupDocumentMode / payload) อ่านผ่าน computed คู่นี้
    // อยู่แล้ว ผลลัพธ์ปลายทางจึงเท่าเดิมเป๊ะ
    agentCodeList: function() {
      var raw = Array.isArray(this.reBHostAgentCode) ? this.reBHostAgentCode : [];
      return this.hasSelectAllOption(raw)
        ? this.realOptionIds(this.reBHostAgentCodeOptions)
        : raw;
    },
    groupCodeList: function() {
      var raw = Array.isArray(this.HeadAgentCode) ? this.HeadAgentCode : [];
      return this.hasSelectAllOption(raw)
        ? this.realOptionIds(this.HeadAgentCodeOptions)
        : raw;
    },
    agentCodeCount: function() {
      return this.agentCodeList.length;
    },
    groupCodeCount: function() {
      return this.groupCodeList.length;
    },
    // filter บังคับเลือกได้อย่างใดอย่างหนึ่ง — เลือกตัวไหนแล้วอีกตัวถูกปิด
    isAgentSelected: function() {
      return this.agentCodeCount > 0;
    },
    isGroupSelected: function() {
      return this.groupCodeCount > 0;
    },
    // รหัสที่จะประมวลผลจริง (มาจาก filter บังคับตัวที่ผู้ใช้เลือกไว้)
    selectedCodes: function() {
      return this.isAgentSelected ? this.agentCodeList : this.groupCodeList;
    },
    // 2 รายขึ้นไป = โหมดสร้างเอกสารรวม (ขั้นที่ 3B)
    isGroupDocumentMode: function() {
      return this.selectedCodes.length > 1;
    },
    // FS-033 — popup ความคืบหน้าอยู่ได้เฉพาะตอนอยู่หน้าเลือก Filter
    //   (route ลูก 3B mount popup ตัวเดียวกัน ห้ามให้อยู่ใน DOM พร้อมกัน)
    isOnFilterStep: function() {
      return this.$route.path === "/PrintSummary/Barcodes/New";
    },
    // ค่าที่ jQuery-validate เอาไปเช็ค required — มีค่าเมื่อเลือก filter บังคับตัวใดตัวหนึ่งแล้ว
    // (ส่งเป็นจำนวนที่เลือก เพื่อให้ค่าเปลี่ยนทุกครั้งที่ผู้ใช้เพิ่ม/ลดรายการ → validator re-check)
    requiredFilterValue: function() {
      var count = this.agentCodeCount + this.groupCodeCount;
      return count > 0 ? String(count) : "";
    },
  },
  data: function() {
    return {
      // ── Filter บังคับ (multi select — เลือกได้อย่างใดอย่างหนึ่ง แต่ในตัวที่เลือกใส่ได้หลายราย) ──
      // ชื่อ v-model/options ใช้ชื่อเดียวกับ Barcodes.vue เพื่อให้ loader copy มาได้ตรง ๆ
      reBHostAgentCode: [],
      reBHostAgentCodeOptions: [],
      HeadAgentCode: [],
      HeadAgentCodeOptions: [],

      // ── Filter ไม่บังคับ (multi select ทั้ง 7 ตัว) ─────────────────────────
      AssetOwnerId: [],
      AssetOwnerOptions: [],
      Circulate: [],
      CirculateOptions: [],
      PeriodRange: [],
      PeriodRangeOptions: [],
      BarcodeYear: [],
      AllBarcodeYearOptions: [],
      PeriodYear: [],
      PeriodYearOptions: [],
      reBProductTypeId: [],
      reBProductTypeIdOptions: [],
      reBAssetCode: [],
      reBAssetCodeOptions: [],

      // ── State ที่ส่งต่อให้ step 2 (/New/Preview, /New/GroupPreview อ่านผ่าน $parent) ──
      // filter object ที่ POST ไปแล้ว — Preview/GroupPreview ใช้ตัวเดียวกันนี้ยิง Save/Export ต่อ
      filter: null,
      // ผลลัพธ์จาก /Api/FormSummaryStock/Process (โหมดตัวแทนรายเดียว)
      processResult: null,
      // ผลลัพธ์จาก /Api/FormSummaryStock/GroupProcess (โหมดสร้างเอกสารรวม — FormSummaryStockGroupPreview.vue:306)
      groupProcessResult: null,
      // รหัสตัวแทนที่เลือกไว้ตอนยิง GroupProcess (GroupPreview ใช้ยิง GroupExportExcel ต่อ — :307)
      groupAgentCodes: [],
      // ข้อความ filter ภาษาไทยที่ประกอบจาก label ฝั่ง client (ใช้เป็น fallback ของ filterText จาก API)
      filterLabels: [],

      // ── FS-033 : state ระหว่างรอผลของงานประมวลผลเบื้องหลัง ────────────────
      //   เก็บ filter ที่ "กำลังประมวลผลอยู่" ไว้ต่างหาก แล้วค่อยย้ายไปที่ filter จริง
      //   เมื่อผลออกมาสำเร็จ — งานที่ถูกยกเลิก/ล้มเหลวจะได้ไม่ไปทับ state ของผลก่อนหน้า
      pendingFilter: null,
      pendingFilterLabels: [],
      pendingIsGroup: false,
    };
  },
  watch: {
    // filter บังคับเลือกได้อย่างใดอย่างหนึ่ง — เลือกตัวหนึ่งแล้วต้องล้างอีกตัวทันที
    // (ไม่เกิด loop เพราะการ set เป็น [] ทำให้ watcher อีกฝั่งเข้าเงื่อนไข length === 0 แล้วจบ)
    reBHostAgentCode: function(val) {
      // FS-010 / FS-016 — option "ทั้งหมด" ต้องได้ผลเท่ากับ "เลือกทุกตัวจริง ๆ"
      // แต่ การขยายเป็นรหัสจริงย้ายไปทำที่ computed agentCodeList แล้ว (FS-016)
      // v-model จึงเก็บแค่ sentinel — กล่องจะได้โชว์ chip "ทั้งหมด" ชิ้นเดียว
      // คงกติกาเดิม: ขณะเลือก Group อยู่ ห้ามเลือกตัวแทนรายตัว
      // (treeselect ถูก :disabled="isGroupSelected" อยู่แล้ว — กันซ้ำที่นี่ไม่ให้เลือกข้ามเงื่อนไขได้)
      if (this.hasSelectAllOption(val)) {
        // FS-016 — เลือก "ทั้งหมด" ให้เหลือ chip เดียวในกล่อง ไม่ใส่รหัสจริงลง v-model
        // (การขยายเป็นรหัสจริงทำที่ computed agentCodeList แล้ว)
        // เงื่อนไข length !== 1 กันไม่ให้ assign ซ้ำจนวน watcher ไม่รู้จบ
        var onlySentinel = this.isGroupSelected ? [] : [SELECT_ALL_ID];
        if (val.length !== onlySentinel.length) {
          this.reBHostAgentCode = onlySentinel;
        }
        this.ClearAfterselect();
        return;
      }
      if (val && val.length > 0 && this.groupCodeCount > 0) {
        this.HeadAgentCode = [];
      }
    },
    HeadAgentCode: function(val) {
      // กติกาเดียวกับด้านบน (ฝั่ง Group) — ขณะเลือกตัวแทนรายตัวอยู่ ห้ามเลือก Group
      if (this.hasSelectAllOption(val)) {
        // FS-016 — กติกาเดียวกับฝั่งตัวแทนรายตัว
        var onlySentinelG = this.isAgentSelected ? [] : [SELECT_ALL_ID];
        if (val.length !== onlySentinelG.length) {
          this.HeadAgentCode = onlySentinelG;
        }
        this.ClearAfterselect();
        return;
      }
      if (val && val.length > 0 && this.agentCodeCount > 0) {
        this.reBHostAgentCode = [];
      }
    },
  },
  methods: {
    // ─────────────────────────────────────────────────────────────────────────
    // Dropdown loaders — copy จาก SBP.Web/App/Components/Report/Barcodes.vue
    // ─────────────────────────────────────────────────────────────────────────

    /***** ddl ชื่อตัวแทนจำหน่าย — ที่มา: Barcodes.vue:1546 LoadreBHostAgentCodeOptions *****/
    LoadreBHostAgentCodeOptions: function(e) {
      var self = this;
      // FS-023 — ต้องใช้ endpoint ของ CR นี้เท่านั้น
      //   /Api/Report/Select2Agent ไม่มี branch ของ FORM_SUMMARY_STOCK_* (ReportController.cs:205-352)
      //   ผู้ใช้กลุ่ม B จึงร่วงผ่าน if/else ทั้งชุดแล้วได้ AgentCodes ว่าง = ไม่ถูกกรอง
      //   วัดจริง 25/09/2026: TESTFSSAGENT (มีสิทธิ์ 2 ราย) ได้ 94 ราย
      axios
        .post("/Api/FormSummaryStock/Select2Agent", {
          page: 1,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            // FS-010 — "ทั้งหมด" เป็น option แรก และใส่ก็ต่อเมื่อมีตัวเลือกมากกว่า 1 รายการ
            // (เงื่อนไขเดิมของปุ่ม `options.length > 1` ตรงกับแพตเทิร์น `data.length > 1` ของระบบพอดี)
            self.reBHostAgentCodeOptions =
              data.length > 1 ? [{ id: SELECT_ALL_ID, label: "ทั้งหมด" }] : [];
            data.forEach((element) => {
              self.reBHostAgentCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },

    /***** ddl ตัวแทนจำหน่าย (Group) — ที่มา: Barcodes.vue:1242 LoadHeadAgentCodeOptions *****/
    // ต่างจากต้นทาง 3 จุด (ตั้งใจ):
    //   1) ต้นทางส่ง department: self.rePMRegion (ตัวกรอง Region ของหน้ารายงาน) — หน้านี้ไม่มี Region → ส่ง []
    //      เหมือนที่ LoadreBHostAgentCodeOptions ทำ
    //   2) ต้นทางแทรก option { id: "0", label: "ทั้งหมด" } เสมอ — หน้านี้แทรกเฉพาะตอนมีตัวเลือก > 1 รายการ
    //      และ watcher จะขยาย sentinel "0" เป็นรหัสจริงทุกตัวทันทีที่ผู้ใช้เลือก
    //      (spec ต้องการรหัสจริงทุกตัวใน payload เพื่อสร้างเอกสารทีละฉบับ ไม่ใช่ sentinel "0")
    //   3) ส่ง IsHead: true (spec ฉบับเซ็น 16/09/2026 — ตัวเลือกเหลือเฉพาะสำนักงานใหญ่ + ตัวแทนที่ไม่มีสาขา)
    //      Select2SearchAgentCodeQueryHandler.cs:113-141 แทนค่า ID/Text ของทุกรายด้วย
    //      HEAD_OFFICE_CODE_SAP ของตัวเอง แล้ว GroupBy ทิ้งตัวซ้ำ → สาขาถูกยุบเข้าสำนักงานใหญ่หมด
    //      ส่วนตัวแทนที่ไม่มีสาขาชี้ HEAD_OFFICE_CODE_SAP กลับหาตัวเอง จึงยังอยู่ในรายการ 1 ราย
    //      (FS-023 — ย้ายมาใช้ /Api/FormSummaryStock/Select2Agent แล้ว ซึ่งส่ง IsHead ต่อให้ query ตรง ๆ)
    LoadHeadAgentCodeOptions: function(e) {
      var self = this;
      // FS-023 — เหตุผลเดียวกับ dropdown ด้านบน · endpoint ของ CR นี้รับ IsHead แล้ว
      //   และบังคับ AgentCodes ก่อนยุบสาขา จึงได้เฉพาะสำนักงานใหญ่ที่อยู่ในสิทธิ์
      axios
        .post("/Api/FormSummaryStock/Select2Agent", {
          page: 1,
          IsHead: true,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            // FS-010 — เงื่อนไขเดียวกับ dropdown "ชื่อตัวแทนจำหน่าย"
            self.HeadAgentCodeOptions =
              data.length > 1 ? [{ id: SELECT_ALL_ID, label: "ทั้งหมด" }] : [];
            data.forEach((element) => {
              self.HeadAgentCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },

    /***** ddl เจ้าของทรัพย์สิน — ที่มา: Barcodes.vue:1705 LoadAssetOwnerOptions *****/
    LoadAssetOwnerOptions: function(e) {
      var self = this;
      axios
        .get("/Api/assetOwner/Select2SearchAssetOwner", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.AssetOwnerOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },

    /***** ddl หมุนเวียน/ไม่หมุนเวียน — ที่มา: Barcodes.vue:1685 LoadCirculateOptions (ไม่มี endpoint) *****/
    LoadCirculateOptions: function(e) {
      var self = this;
      self.CirculateOptions = [];
      var data = [
        {
          id: 1,
          text: "หมุนเวียน",
        },
        {
          id: 2,
          text: "ไม่หมุนเวียน",
        },
      ];
      data.forEach((element) => {
        self.CirculateOptions.push({
          id: element.id,
          label: element.text,
        });
      });
    },

    /***** ddl ช่วงคงค้าง — ที่มา: Barcodes.vue:1650 LoadOdPeriodOptions *****/
    LoadOdPeriodOptions() {
      var self = this;
      axios
        .get("/Api/ReportOverdue/Select2PeriodOption", {
          params: {
            page: 1,
            all: true,
            PeriodRangeType: 2,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.PeriodRangeOptions = [];
            data.forEach((element) => {
              self.PeriodRangeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },

    /***** ddl ปี(สินค้า) — ที่มา: Barcodes.vue:1596-1599 reLoadBarcodeYearOptions / LoadBarcodeYearOptions *****/
    reLoadBarcodeYearOptions: function() {
      // $refs safety (.claude/rules/vue-patterns.md) — treeselect อยู่ใน v-show จึงมีเสมอ
      // แต่ trigger จะยังไม่ถูกสร้างถ้า event open ยิงก่อน child mount เสร็จ
      if (this.$refs.BarcodeYear && this.$refs.BarcodeYear.trigger) {
        this.$refs.BarcodeYear.trigger.searchQuery = null;
      }
    },
    LoadBarcodeYearOptions({ action, searchQuery, callback }) {
      if (this.AllBarcodeYearOptions.length === 0) {
        axios
          .get("/Api/Report/Select2BarcodeYear", {
            params: {
              page: 1,
              all: true,
            },
          })
          .then((response) => {
            if (response.status === 200) {
              this.AllBarcodeYearOptions = response.data.results.map((element) => ({
                id: element.id,
                label: element.text,
              }));
              callback(null, this.AllBarcodeYearOptions);
            }
          })
          .catch((error) => {
            callback(error, []);
          });
      } else {
        const query = searchQuery ? searchQuery.toLowerCase() : "";
        const filteredOptions = this.AllBarcodeYearOptions.filter((option) =>
          option.label.toLowerCase().includes(query)
        );
        callback(null, filteredOptions);
      }
    },

    /***** ddl ปีคงค้าง — ที่มา: Barcodes.vue:1674 LoadPeriodYearOptions (ไม่มี endpoint · 2021 → ปีปัจจุบัน) *****/
    LoadPeriodYearOptions: function(e) {
      var self = this;
      self.PeriodYearOptions = [];
      var currentYear = new Date().getFullYear();
      for (let year = 2021; year <= currentYear; year++) {
        self.PeriodYearOptions.push({
          id: year.toString(),
          label: year.toString(),
        });
      }
    },

    /***** ddl ประเภทสินค้า — ที่มา: Barcodes.vue:1127 LoadreBProductTypeIdOptions *****/
    LoadreBProductTypeIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductType/Select2ProductType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reBProductTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },

    /***** ddl ชื่อสินค้า — ที่มา: Barcodes.vue:1171 LoadreBAssetCodeOptions *****/
    LoadreBAssetCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: {
            page: 1,
            all: true,
            excludeProductGroupId: 14,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              // CR-01 (08/10/2026) — ไม่แสดงสินค้าของร้านค้าใน dropdown
              //   เครื่องส่วนบุคคล [COOL-ROOM-01] · หัวจ่ายส่วนบุคคล [FONT-SHOP-01]
              //   กรองฝั่งนี้เพราะ /Api/Product/Select2Product เป็น endpoint กลาง
              //   ที่โมดูลอื่นใช้ร่วมด้วย แก้ที่นั่นจะกระทบหน้าจออื่นทั้งระบบ
              //   (ฝั่งข้อมูลกรองซ้ำอีกชั้นที่ GetFormSummaryStockBarcodesQueryHandler
              //    เพื่อให้ยอดรวม / Excel / PDF ไม่นับ แม้ผู้ใช้จะส่งรหัสมาเองตรง ๆ)
              if (EXCLUDED_PRODUCT_CODES.indexOf(String(element.id)) >= 0) return;

              self.reBAssetCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },

    /***** ที่มา: Barcodes.vue:1789 ClearAfterselect *****/
    ClearAfterselect: function() {
      $(`[class="vue-treeselect__input"]`).val("");
    },

    // ─────────────────────────────────────────────────────────────────────────
    // Form actions
    // ─────────────────────────────────────────────────────────────────────────

    // ── option "ทั้งหมด" (FS-010) ────────────────────────────────────────────
    // เดิมเป็นปุ่ม selectAllAgentCodes/selectAllGroupCodes นอก dropdown
    // ย้ายมาเป็น option แรกของ dropdown แล้ว แต่ "ผลลัพธ์" ต้องเท่าเดิมเป๊ะ คือ
    // ใส่รหัสจริงทุกตัวที่ dropdown มีลง v-model (ไม่ปล่อย sentinel "0" หลุดไปกับ payload)
    // เพราะปลายทางต้องสร้างเอกสารทีละฉบับตามรหัสจริง
    // ขอบเขตของแอดมิน (ตัวแทนจำหน่าย) ถูกบังคับที่ /Api/FormSummaryStock/Select2Agent (FS-023)
    // → "ทั้งหมด" ของผู้ใช้กลุ่มนี้ = เฉพาะรายที่อยู่ในโปรไฟล์ (spec F03)
    // (ก่อน FS-023 คอมเมนต์นี้ไม่จริง — หน้านี้เคยโหลดจาก /Api/Report/Select2Agent ซึ่งไม่กรองอะไรเลย)

    // ค่าที่เลือกอยู่มี option "ทั้งหมด" ปนมาหรือไม่
    hasSelectAllOption: function(values) {
      return (
        Array.isArray(values) &&
        values.some(function(v) {
          return String(v) === SELECT_ALL_ID;
        })
      );
    },

    // รหัสจริงทุกตัวใน dropdown (ตัด sentinel "ทั้งหมด" ออก)
    realOptionIds: function(options) {
      return (options || [])
        .filter(function(o) {
          return String(o.id) !== SELECT_ALL_ID;
        })
        .map(function(o) {
          return o.id;
        });
    },

    // แปลง id ที่เลือก → ข้อความ label สำหรับ echo ให้ผู้ใช้อ่านในขั้นที่ 2
    labelsOf: function(options, values) {
      if (!options || !values) return "";
      var list = Array.isArray(values) ? values : [values];
      if (list.length === 0) return "";

      var map = {};
      options.forEach(function(o) {
        map[String(o.id)] = o.label;
      });

      return list
        .map(function(v) {
          return map[String(v)] != null ? map[String(v)] : String(v);
        })
        .join(", ");
    },

    // สรุป filter ที่ผู้ใช้เลือกเป็นคู่ label/ค่า — ใช้เป็น fallback เมื่อ API ไม่ส่ง filterText มา
    buildFilterLabels: function() {
      var self = this;
      var pairs = [];

      // QA 08/10/2026 เรื่องที่ 9 — ผู้ใช้เลือก "ทั้งหมด" ต้องแสดงคำว่า "ทั้งหมด"
      //   ไม่ใช่กางรายชื่อตัวแทน 100+ รายจนเต็มกล่องจนอ่านไม่ออก
      //   ค่าที่ผู้ใช้เลือกจริงอยู่ใน v-model (sentinel "0") ส่วน agentCodeList/groupCodeList
      //   เป็นรหัสที่ขยายแล้วสำหรับส่ง API — การแสดงผลจึงต้องดูจาก v-model
      if (self.isAgentSelected) {
        pairs.push({
          label: "ชื่อตัวแทนจำหน่าย",
          text: self.hasSelectAllOption(self.reBHostAgentCode)
            ? SELECT_ALL_LABEL
            : self.labelsOf(self.reBHostAgentCodeOptions, self.agentCodeList),
        });
      }
      if (self.isGroupSelected) {
        pairs.push({
          label: "ตัวแทนจำหน่าย (Group)",
          text: self.hasSelectAllOption(self.HeadAgentCode)
            ? SELECT_ALL_LABEL
            : self.labelsOf(self.HeadAgentCodeOptions, self.groupCodeList),
        });
      }

      var optional = [
        ["เจ้าของทรัพย์สิน", self.AssetOwnerOptions, self.AssetOwnerId],
        ["หมุนเวียน/ไม่หมุนเวียน", self.CirculateOptions, self.Circulate],
        ["ช่วงคงค้าง", self.PeriodRangeOptions, self.PeriodRange],
        ["ปี(สินค้า)", self.AllBarcodeYearOptions, self.BarcodeYear],
        ["ปีคงค้าง", self.PeriodYearOptions, self.PeriodYear],
        ["ประเภทสินค้า", self.reBProductTypeIdOptions, self.reBProductTypeId],
        ["ชื่อสินค้า", self.reBAssetCodeOptions, self.reBAssetCode],
      ];

      optional.forEach(function(item) {
        if (item[2] && item[2].length > 0) {
          // หลักเดียวกับ filter บังคับ — เลือก "ทั้งหมด" ก็แสดง "ทั้งหมด"
          pairs.push({
            label: item[0],
            text: self.hasSelectAllOption(item[2])
              ? SELECT_ALL_LABEL
              : self.labelsOf(item[1], item[2]),
          });
        }
      });

      return pairs;
    },

    // payload ที่ตรงกับ SBP.Application/FormSummaryStock/Models/FormSummaryStockFilter.cs
    // และ FormSummaryStockGroupFilterRequest (GetFormSummaryStockGroupSummaryQuery.cs:56) ที่เพิ่ม agentCodes
    // (ไม่ส่ง IsSuperAdmin / AllowedAgentCodes — controller เป็นผู้เซ็ตเท่านั้น)
    //
    // ส่ง agentCodes ติดไปทุกครั้ง แม้เส้นทางตัวแทนรายเดียว:
    //   • /Process bind เป็น FormSummaryStockFilter ซึ่งไม่มี property นี้ → JSON binder ข้ามให้เอง
    //   • แต่ FormSummaryStockGroupPreview.vue:412-416 ใช้ $parent.filter.agentCodes เป็นค่าสำรอง
    //     จึงต้องมีติดอยู่ใน object เดียวกับที่เก็บไว้บน this.filter
    // ส่วน agentCode / headAgentCode เติมเฉพาะตอนเลือกรายเดียว (เส้นทางเดิมของขั้นที่ 3 ใช้ค่านี้)
    buildFilter: function() {
      var self = this;
      var isAgent = self.isAgentSelected;
      var codes = self.selectedCodes.map(function(v) {
        return String(v);
      });
      var single = codes.length === 1 ? codes[0] : null;

      // FS-091 — บอก server ว่าผู้ใช้เลือก "ทั้งหมด" หรือเลือกบางราย (ใช้ตั้งชื่อไฟล์รวม)
      //   ต้องดูจาก v-model (sentinel "0") เพราะ codes ถูกขยายเป็นรหัสจริงไปแล้ว แยกจากการติ๊กครบเองไม่ได้
      //   ส่งเฉพาะโหมดหลายตัวแทน — ตัวแทนรายเดียวไม่มีไฟล์รวม
      var isAllAgents =
        codes.length > 1
          ? self.hasSelectAllOption(isAgent ? self.reBHostAgentCode : self.HeadAgentCode)
          : null;

      return {
        filterType: isAgent ? FILTER_TYPE_AGENT : FILTER_TYPE_GROUP,
        agentCode: isAgent ? single : null,
        headAgentCode: isAgent ? null : single,
        agentCodes: codes,
        isAllAgents: isAllAgents,
        assetOwnerId: toIntList(self.AssetOwnerId),
        circulate: toIntList(self.Circulate),
        periodRange: toIntList(self.PeriodRange),
        barcodeYear: toIntList(self.BarcodeYear),
        periodYear: toIntList(self.PeriodYear),
        productTypeId: toIntList(self.reBProductTypeId),
        assetCode: toStringList(self.reBAssetCode),
      };
    },

    goBack: function() {
      router.push({ path: "/PrintSummary/Barcodes" });
    },

    formReset: function(e) {
      // "ล้างข้อมูล" = ล้างเฉพาะเงื่อนไขบนฟอร์ม ไม่ได้ลบข้อมูลจริง
      this.reBHostAgentCode = [];
      this.HeadAgentCode = [];
      this.AssetOwnerId = [];
      this.Circulate = [];
      this.PeriodRange = [];
      this.BarcodeYear = [];
      this.PeriodYear = [];
      this.reBProductTypeId = [];
      this.reBAssetCode = [];

      this.filter = null;
      this.processResult = null;
      this.groupProcessResult = null;
      this.groupAgentCodes = [];
      this.filterLabels = [];

      this.ClearAfterselect();

      // $refs safety — ฟอร์มอยู่ใน v-show (ไม่ใช่ v-if) จึงมีเสมอ แต่กันไว้เผื่อ reset ถูกเรียกก่อน mount เสร็จ
      if (this.$refs.filterForm) {
        var validator = $(this.$refs.filterForm).data("validator");
        if (validator) {
          validator.resetForm();
        }
      }
    },

    // ข้อความ error กลางของ axios catch — ใช้ร่วมกันทั้ง 2 เส้นทาง
    describeAxiosError: function(error) {
      return error && error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : "เกิดข้อผิดพลาด";
    },

    // "ประมวลผล" — แยกเส้นทางตามจำนวนตัวแทนที่เลือก (spec ฉบับเซ็น 16/09/2026)
    //   1 ราย      → /Process      → /New/Preview       (เอกสารเดียว — เส้นทางเดิม)
    //   2 รายขึ้นไป → /GroupProcess → /New/GroupPreview  (ขั้นที่ 3B — สร้างเอกสารรวม)
    formSubmit: function(e) {
      if (e) e.preventDefault();

      var self = this;

      if (!self.$refs.filterForm) return;
      if (!$(self.$refs.filterForm).valid()) return;

      if (self.isGroupDocumentMode) {
        self.submitGroupProcess();
      } else {
        self.submitSingleProcess();
      }
    },

    // ── FS-033 : "ประมวลผล" เป็นงานเบื้องหลัง + popup ความคืบหน้า ───────────
    //
    //   spec §M นับ "กด ประมวลผล (ขั้นที่ 2 → 3B)" เป็น 1 ใน 5 กรณีที่ต้องมี Popup Progress
    //   ของเดิมเป็น request เดียวที่รอจนจบแล้วบล็อกหน้าจอด้วย KTApp.blockPage
    //   → ไม่มี % ไม่มี log ไม่มีปุ่มยกเลิก และชุดใหญ่ ๆ เสี่ยงชน timeout ของ HTTP/reverse proxy
    //
    //   ตอนนี้ทั้ง 2 เส้นทางยิง endpoint ที่คืน jobId ทันที แล้วให้ popup poll ความคืบหน้าเอง
    //   ผลลัพธ์จริงมารับทีหลังด้วย ProcessResult / GroupProcessResult (รูปร่างเดิมทุกประการ)

    submitSingleProcess: function() {
      var self = this;
      var filter = self.buildFilter();

      self.pendingFilter = filter;
      self.pendingFilterLabels = self.buildFilterLabels();
      self.pendingIsGroup = false;

      // FS-078 — เปิด popup ความคืบหน้าทันทีเหมือนโหมดหลายตัวแทน ไม่มี overlay spinner คั่นก่อน
      //   ของเดิม (FS-033) หน่วง popup 700ms แล้วใช้ KTApp.blockPage คั่นช่วงนั้น
      //   ผู้ใช้: popup คือ loading ของขั้นนี้อยู่แล้ว ไม่ต้องมี spinner อีกชั้น
      self.$refs.progressModal.start({
        title: "กำลังประมวลผลข้อมูล",
        jobKind: "process",
        showTimer: true, // FS-126
        payload: filter,
        endpoints: { start: "/Api/FormSummaryStock/ProcessStart" },
      });
    },

    submitGroupProcess: function() {
      var self = this;
      var filter = self.buildFilter();

      self.pendingFilter = filter;
      self.pendingFilterLabels = self.buildFilterLabels();
      self.pendingIsGroup = true;

      // โหมดรวมวนอย่างน้อย 2 ตัวแทน ไม่มีทางจบเร็วพอจะกระพริบ → เปิด popup ทันที
      //   FS-105 — ติดขัดที่รายไหน popup หยุดรอให้เลือก "ประมวลผลใหม่" / "ข้าม" ผ่าน GroupProcessResume
      self.$refs.progressModal.start({
        title:
          "กำลังประมวลผลข้อมูล " + filter.agentCodes.length + " ตัวแทนจำหน่าย",
        jobKind: "process",
        showTimer: true, // FS-126
        payload: filter,
        endpoints: {
          start: "/Api/FormSummaryStock/GroupProcessStart",
          resume: "/Api/FormSummaryStock/GroupProcessResume",
        },
      });
    },

    // งานประมวลผลจบแล้ว (จบเอง / ยกเลิก / ล้มเหลว)
    //
    //   spec: "เมื่อประมวลผลจบครบทั้งหมด → ปิด popup อัตโนมัติ → เข้าสู่หน้าถัดไป"
    //   จึงรับผลก่อน แล้วค่อยสั่งปิด popup เอง (ไม่ให้ popup ปิดตัวเองก่อนแล้วจอโล่งรอ API)
    //   งานที่ถูกยกเลิก/ล้มเหลว ปล่อยให้ popup ค้างไว้พร้อมข้อความและปุ่มปิด
    onProcessFinished: function(summary) {
      var self = this;

      if (!summary || summary.state !== "Completed") return;

      var isGroup = self.pendingIsGroup;
      var resultUrl = isGroup
        ? "/Api/FormSummaryStock/GroupProcessResult"
        : "/Api/FormSummaryStock/ProcessResult";

      axios
        .post(
          resultUrl,
          { batchId: summary.batchId },
          { headers: { Authorization: "Bearer " + self.$root.user.access_token } }
        )
        .then(function(response) {
          var data = (response && response.data) || {};

          if (!data.success) {
            // ประมวลผลไม่ผ่าน (เช่น filter ไม่ถูกต้อง / ไม่มีข้อมูล)
            // → ปิด popup แล้วอยู่หน้าเดิมให้ผู้ใช้แก้ filter ได้ทันที
            self.closeProgress();
            Swal.fire(
              "เกิดข้อผิดพลาด",
              data.message || "ไม่สามารถประมวลผลข้อมูลได้",
              "error"
            );
            return;
          }

          // เก็บไว้บน component นี้ (route แม่) ให้ step 2 อ่านผ่าน $parent
          self.filter = self.pendingFilter;
          self.filterLabels = self.pendingFilterLabels;

          if (isGroup) {
            // ชื่อ property ต้องตรงกับที่ FormSummaryStockGroupPreview.vue ประกาศไว้
            self.groupProcessResult = data;

            // FS-105 — ตัวแทนที่ติดขัดแล้วผู้ใช้กด "ข้าม" ต้องไม่ถูกส่งไปบันทึก/Export ในรอบนี้
            //   (ผู้ใช้ต้องไปสร้างเอกสารของรายนั้นเองภายหลัง) — ขั้นที่ 2 ใช้รายการนี้ส่งต่อ
            var failedCodes = (data.failedAgents || []).map(function(agent) {
              return agent.agentCode;
            });
            self.groupAgentCodes = self.pendingFilter.agentCodes.filter(function(code) {
              return failedCodes.indexOf(code) === -1;
            });
            self.processResult = null;
          } else {
            self.processResult = data;
            // ล้าง state ของโหมดรวม กัน GroupPreview อ่านผลค้างจากการประมวลผลครั้งก่อน
            self.groupProcessResult = null;
            self.groupAgentCodes = [];
          }

          self.closeProgress();

          router.push({
            path: isGroup
              ? "/PrintSummary/Barcodes/New/GroupPreview"
              : "/PrintSummary/Barcodes/New/Preview",
          });
        })
        .catch(function(error) {
          self.closeProgress();
          Swal.fire("เกิดข้อผิดพลาด", self.describeAxiosError(error), "error");
        });
    },

    // ปิด popup อย่างปลอดภัย — ถูกเรียกหลัง await จึงอาจไม่มี component อยู่แล้ว
    closeProgress: function() {
      if (this.$refs.progressModal) this.$refs.progressModal.close();
    },
  },
  async mounted() {
    let self = this;

    await this.$nextTick();

    // โหลด dropdown ทั้งหมด (ยกเว้น ปี(สินค้า) ที่เป็น async load-options โหลดตอนเปิด dropdown)
    self.LoadreBHostAgentCodeOptions();
    self.LoadHeadAgentCodeOptions();
    self.LoadAssetOwnerOptions();
    self.LoadCirculateOptions();
    self.LoadOdPeriodOptions();
    self.LoadPeriodYearOptions();
    self.LoadreBProductTypeIdOptions();
    self.LoadreBAssetCodeOptions();

    // ── Validation ─────────────────────────────────────────────────────────
    // ignore: [] เพื่อให้ validator เห็น hidden input ที่ผูกกับ filter บังคับ
    // (pattern เดียวกับ AgentScoreList.vue:825-855)
    if (self.$refs.filterForm) {
      $(self.$refs.filterForm).validate({
        ignore: [],
        errorElement: "div",
        errorClass: "text-danger kt-margin-b-10",
        rules: {
          fssCreate_requiredFilter: {
            required: true,
          },
        },
        messages: {
          fssCreate_requiredFilter: {
            required:
              "กรุณาเลือก ชื่อตัวแทนจำหน่าย หรือ ตัวแทนจำหน่าย (Group) อย่างใดอย่างหนึ่ง",
          },
        },
      });
    }
  },
};
</script>

<style lang="scss" scoped>

/*
  FS-058 — ผู้ใช้ขอ "ดอกจันแดง" เพิ่มจากแถบแดงของคลาสส่วนกลาง

  .label-required ของส่วนกลาง (App.vue) วาด "แถบแดงตั้ง" ไว้หน้า label ด้วย ::before
  ตรงนี้เติม ::after เป็นดอกจันแดงต่อท้าย จึงได้ทั้งสองอย่างตามที่ผู้ใช้ขอ

  scoped จึงมีผลเฉพาะหน้านี้ ไม่กระทบอีก ~98 component ที่ใช้คลาสเดียวกัน
*/
.label-required::after {
  content: " *";
  color: #f4516c;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// App/Components/PrintSummary/FormSummaryStockCreate.vue